export default {
    BG_ERITRANCE: '/img/bg/bg-entrance.jpg',
    LOGO: "/img/logo.png"
}
